/** Definir/redefinir senha a partir do link do e-mail (convite de membro ou "esqueci minha senha"). */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { z } from 'zod';
import { get, post } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Campo } from '../ui/campos';

export const Route = createFileRoute('/redefinir')({ validateSearch: z.object({ token: z.string().optional(), convite: z.string().optional() }), component: Redefinir });

function Redefinir() {
  const { token, convite } = Route.useSearch();
  const nav = useNavigate();
  const auth = useAuth();
  const info = useQuery({ queryKey: ['token', token], queryFn: () => get<{ valido: boolean; tipo: 'CONVITE' | 'RESET' | null; nome: string | null; email: string | null }>('/v1/auth/token', { token }), enabled: !!token });
  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [feito, setFeito] = useState(false);
  const ehConvite = convite === '1' || info.data?.tipo === 'CONVITE';

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    if (senha !== confirma) { setErro('as senhas não conferem'); return; }
    setEnviando(true);
    try {
      await post('/v1/auth/redefinir', { token, senha });
      setFeito(true);
      if (info.data?.email) { await auth.entrar(info.data.email, senha); await nav({ to: '/' }); }
    } catch (err) { setErro(err instanceof Error ? err.message : 'não foi possível salvar'); } finally { setEnviando(false); }
  }

  return (
    <div className="entrada">
      <div className="cartao">
        <div className="marca"><span className="logo-mark">SGC</span><div><h1>{ehConvite ? 'Bem-vindo(a)' : 'Nova senha'}</h1><div className="sub">{info.data?.nome ? `${info.data.nome} · ${info.data.email}` : 'gestão de tarefas e obrigações do escritório'}</div></div></div>
        {!token || (info.data && !info.data.valido) ? (
          <div className="alerta erro">Este link não vale mais. {ehConvite ? 'Peça ao administrador para reenviar o convite.' : 'Peça outro em "esqueci minha senha".'}</div>
        ) : feito ? <div className="alerta ok">Senha salva. Entrando…</div> : (
          <form onSubmit={enviar}>
            {erro && <div className="alerta erro">{erro}</div>}
            <Campo rotulo={ehConvite ? 'Escolha sua senha' : 'Nova senha'} valor={senha} onChange={setSenha} type="password" autoComplete="new-password" autoFocus required ajuda="mínimo 8 caracteres, com letra e número" />
            <Campo rotulo="Repita a senha" valor={confirma} onChange={setConfirma} type="password" autoComplete="new-password" required />
            <button className="btn primario" type="submit" disabled={enviando || !info.data?.valido}>{enviando ? 'salvando…' : ehConvite ? 'Entrar no SGC' : 'Salvar senha'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
